import React, { createContext, useContext, useMemo, useState } from "react";

export type PageLoginStateProps = {
  hasEmail: boolean;
  setHasEmail: (state: boolean) => void;
  status: number;
  setStatus: (state: number) => void;
};

const notReady = (msg: string) => {
  return () => {
    console.warn(msg);
  };
};

export const initialPageLoginState: PageLoginStateProps = {
  hasEmail: false,
  setHasEmail: notReady("unable to set email: page login state is not ready"),
  status: -1,
  setStatus: notReady("unable to set status: page login state is not ready"),
};

export const PageLoginState = createContext<PageLoginStateProps>(initialPageLoginState);

export const usePageLoginState = () => useContext(PageLoginState);

export type PageLoginProviderProps = React.AllHTMLAttributes<HTMLElement>;

export const PageLoginProvider = ({ children }: PageLoginProviderProps) => {
  const [hasEmail, setHasEmail] = useState(initialPageLoginState.hasEmail);
  const [status, setStatus] = useState(initialPageLoginState.status);

  const context = useMemo(() => {
    return {
      hasEmail,
      setHasEmail,
      status,
      setStatus,
    };
  }, [hasEmail, status]);

  return <PageLoginState.Provider value={context}>{children}</PageLoginState.Provider>;
};
